import { IContentViewModelProperty } from '~/interfaces/contentViewInterfaces'
import ContentViewModelProperty from '~/models/contentManagement/contentViewModelProperties/contentViewModelProperty'
import { IObjectModelRelation } from '~/interfaces/objectModelInterfaces'
import ObjectModelRelationDefinition from '~/models/objectModelRelations/objectModelRelationDefinition'

export default class ContentViewModelPropertyObjectModelRelation extends ContentViewModelProperty implements IContentViewModelProperty {
  canHaveFormat: false = false
  canHaveCharacterCount: false = false
  charLimit: null
  format: null
  hasMinOrMaxLength: null

  constructor(public property: IObjectModelRelation) {
    super(property)
  }

  get name(): string {
    return ObjectModelRelationDefinition.getDisplayName(this.property.relationType)
  }
}